import _ from "lodash"
import { api } from "lib/utils/api"

/** ==============================================================================
 *  Anytime we need to extract a value from the api feed,
 *  we use the function below.
 * 
 *  This function requires:
 * 
 *  - the data feed itself (dataObj)
 *  - the global api data (apiData)
 *  - either:
 *    - a string representing the path to the value we want to extract
 *    - a string representing the placeholder value of the item we want to extract
 *  - a string indicating which of the two parameters above we want to use
 * 
 * ================================================================================ */

interface GetValueFromApiProps {
  clientDataObj:any 
  apiData:any
  lookupType: "path" | "placeholder"
  lookupValue:string
}


function getClientDataFromPath(dataObj:any, path:string) {
  return _.get(dataObj, path) // Use lodash to get the value from the path
}


export function lookupClientData({ clientDataObj, apiData, lookupType, lookupValue }:GetValueFromApiProps) {
  let report = ""
  let result = null 

  if( lookupType === "path" ) {

    try {
      result = getClientDataFromPath(clientDataObj, lookupValue) 
    } catch(error) {
      report += `Error getting value from path "${lookupValue}": ${error}`
    }

  } else {

    let path 
    // look up the placeholder in apiData and get the associated path
    try {
      path = apiData.find( (item:any) => item.placeholder === lookupValue )?.path
      if( !path ) {
        report += `No path found for placeholder "${lookupValue}"`
        throw new Error(`No path found for placeholder "${lookupValue}"`)
      } else {
        report += `Found path "${path}" for placeholder "${lookupValue}"`
      }
    } catch(error) {
      report += `Error finding path for placeholder "${lookupValue}": ${error}`
    }

    if( path ) {
      try {
        result = getClientDataFromPath(clientDataObj, path)
      } catch(error) {
        report += `Error getting value from path "${path}": ${error}`
      }
    }

  }

  // console.log("api value found", result)
  return { result, report }
}